exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".backdrop[data-v-32e4d560]{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#ccc}.backdrop.fade[data-v-32e4d560]{opacity:0}.backdrop.show[data-v-32e4d560]{opacity:.8}.modal .modal-body[data-v-32e4d560]{overflow:hidden;background-color:#4a4a4a}.modal .sidebar[data-v-32e4d560]{height:100%;width:400px;overflow-y:auto}.modal .content[data-v-32e4d560]{position:relative;height:100%;width:100%;overflow-y:auto;background-color:hsla(0,0%,100%,.8)}.modal .settings-footer[data-v-32e4d560]{position:fixed;bottom:0;left:0;right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32e4d560","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./scss/next/_wp_variables.scss","./node_modules/bootstrap/scss/_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/base/settings.vue
// module id = 1462
// module chunks = 132